module.exports = __webpack_public_path__ + "media/icon_transaction/frog_3-d135234f.png";